import { apiGet } from "utils/apiClient";

export const PANEL_TYPES = ["acciones", "bonos", "letras", "cedears", "on"] as const;
export type PanelType = (typeof PANEL_TYPES)[number];

/** Panel type including crypto (for context and AddOperationCard) */
export type PanelTypeWithCrypto = PanelType | "crypto";

/** Includes crypto for portfolio filtering and AddOperationCard (crypto uses CoinGecko, not IOL) */
export const PORTFOLIO_PANEL_FILTERS = [...PANEL_TYPES, "crypto"] as const;
export type PortfolioPanelFilter = (typeof PORTFOLIO_PANEL_FILTERS)[number];

/** Predefined crypto assets for AddOperationCard */
export const CRYPTO_OPTIONS: { symbol: string; name: string; coingeckoId: string }[] = [
  { symbol: "BTC", name: "Bitcoin", coingeckoId: "bitcoin" },
  { symbol: "ETH", name: "Ethereum", coingeckoId: "ethereum" },
  { symbol: "USDT", name: "Tether", coingeckoId: "tether" },
  { symbol: "USDC", name: "USD Coin", coingeckoId: "usd-coin" },
  { symbol: "BNB", name: "BNB", coingeckoId: "binancecoin" },
  { symbol: "SOL", name: "Solana", coingeckoId: "solana" },
  { symbol: "XRP", name: "XRP", coingeckoId: "ripple" },
  { symbol: "ADA", name: "Cardano", coingeckoId: "cardano" },
  { symbol: "AVAX", name: "Avalanche", coingeckoId: "avalanche-2" },
  { symbol: "DOGE", name: "Dogecoin", coingeckoId: "dogecoin" },
];

export interface MarketQuotesResponse {
    headers: string[];
    rows: Record<string, string | number | null>[];
    updatedAt: string;
}

export async function fetchCotizaciones(panel: PanelType): Promise<MarketQuotesResponse> {
    return apiGet<MarketQuotesResponse>(`/market/cotizaciones/${panel}`);
}
